import React from 'react';
import {
  ArrayInput,
  ReferenceInput,
  required,
  FormDataConsumer,
  SelectInput,
  SimpleFormIterator,
  TextInput,
  useTranslate,
} from 'react-admin';
import { Grid } from '@material-ui/core';

const isRequired = [required()];

const Contacts = ({
  className = '',
  isValidated = false,
  source = 'contacts',
  hasDescription = false,
  columns = hasDescription ? 4 : 6,
  ...rest
}) => {
  const translate = useTranslate();

  const validateContacts = (values: any) => {
    const errors: any = [];

    const phoneRegex = /^[0-9]{10,10}$/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const typeMap: Record<number, 'email' | 'phone' | 'cell'> = {
      1: 'email',
      2: 'phone',
      3: 'cell',
    };

    if (!isValidated) return errors;

    if (Array.isArray(values)) {
      values.forEach((contact, index) => {
        const contactErrors: any = {};

        const typeId = contact?.contactType?.id || contact?.contactType;
        const type = typeMap[typeId];
        const value = contact?.contact;

        if (!typeId) {
          contactErrors.contactType = 'El tipo de contacto es obligatorio';
        }

        if (!value) {
          contactErrors.contact = 'El contacto es obligatorio';
        } else {
          if (type === 'phone' || type === 'cell') {
            if (!phoneRegex.test(value)) {
              contactErrors.contact =
                'Debe contener 10 caracteres numéricos';
            }
          } else if (type === 'email') {
            if (!emailRegex.test(value)) {
              contactErrors.contact =
                'Formato de correo invalido';
            }
          }
        }

        if (Object.keys(contactErrors).length > 0) {
          errors[index] = contactErrors;
        }
      });
    }

    return errors;
  };

  return (
    <ArrayInput
      source={source}
      validate={isValidated ? validateContacts : undefined}
      label=''
      {...rest}
    >
      <SimpleFormIterator>
        <FormDataConsumer>
          {({ scopedFormData, getSource }) => (
            <Grid container spacing={2}>
              <Grid item xs={hasDescription ? 4 : 6}>
                <ReferenceInput
                  source={getSource!(
                    rest.record?.id ? 'contactType.id' : 'contactType'
                  )}
                  reference='contact-types'
                  validate={isRequired}
                  variant='outlined'
                  fullWidth
                  label={translate('resources.contacts.fields.contactType')}
                >
                  <SelectInput />
                </ReferenceInput>
              </Grid>
              <Grid item xs={hasDescription ? 4 : 6}>
                <TextInput
                  source={getSource!('contact')}
                  validate={isRequired}
                  variant='outlined'
                  fullWidth
                  label={translate('resources.contacts.fields.contact')}
                  inputProps={{
                    onInput: (e: any) => {
                      const input = e.target;
                      const contactType = scopedFormData?.contactType?.id || scopedFormData?.contactType;

                      if (contactType === 2 || contactType === 3) {

                        input.value = input.value.replace(/[^0-9]/g, '').substring(0, 10);
                      }
                      else if (contactType === 1) {
                        input.value = input.value.replace(/[^a-zA-Z0-9@._-]/g, '');
                      }
                      else {
                        // Por defecto, solo números y máximo 10 caracteres
                        input.value = input.value.replace(/[^0-9]/g, '').substring(0, 10);
                      }
                    }
                  }}
                  transform={(value, record) => {
                    if (!value) return value;

                    const contactType = record?.contactType?.id || record?.contactType;

                    if (contactType === 2 || contactType === 3) {
                      return value.replace(/[^0-9]/g, '').substring(0, 10);
                    }

                    if (contactType === 1) {
                      return value.replace(/[^a-zA-Z0-9@._-]/g, '');
                    }

                    return value.replace(/[^0-9]/g, '').substring(0, 10);
                  }}
                />
              </Grid>
              {hasDescription && (
                <Grid item xs={4}>
                  <TextInput
                    source={getSource!('description')}
                    variant='outlined'
                    fullWidth
                    label={translate('resources.contacts.fields.description')}
                  />
                </Grid>
              )}
            </Grid>
          )}
        </FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  );
};

export default Contacts;
